
// PROD
 export const BASE_URL = 'https://asiavideo.fredeng.eu/api'
// TEST
//export const BASE_URL = 'http://80.211.22.71:3033'